import { api, EnumerationType, ResourcePage, responseErrorCheck, TmrBaseResource } from 'stylewhere/api'

export class EnumerationTypes extends TmrBaseResource {
  static endpoint = 'api/v1/enumerationtypes'

  static getByCode(code: string): Promise<ResourcePage<EnumerationType>> {
    return api.get<ResourcePage<EnumerationType>>(`${this.endpoint}?equalCodes=${code}`).then(responseErrorCheck)
  }
}
